/**
 * defa.views.ConfigView
 * A delay view to make the user please wait.
 * @version 1.2.0
 */
import View     from 'scripts/poppet/view';
import template from 'templates/configView.jst.html';

const ConfigView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'config-view',
	
	// add template-helpers for which config this is?
	templateContext: function () {
		return {
			context: this.options.context || 'device',
		};
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Shows an error message.
	 * @void
	 */
	showErrorMessage: function ( error ) {
		
		let html5 = '<p class="error">%s</p>'.replace( '%s', error.message );
		this.$el.find( '.indeterminate' ).remove();
		this.$el.find( '.error' ).remove();
		this.$el.append( html5 );
	},
} );

export default ConfigView;